// @flow
import * as React from 'react';
// $FlowFixMe
import { useReducer, useRef } from 'react';
import { isYoutubeVideo, getYoutubeVideoID } from 'lib/pwr-cloudinary';
import classnames from 'classnames';
import nanoid from 'nanoid';

type Props = {
  onChange: (*) => void,
};
export function URLUploadControl(props: Props) {
  const id = useRef(nanoid());
  const { onChange } = props;
  const [{ url, isLoading, error }, dispatch] = useReducer(reducer, {
    isLoading: false,
    error: null,
    url: '',
  });

  async function handleSubmit(e) {
    e.preventDefault();
    dispatch({ type: 'submit' });

    try {
      const payload = await validateMediaURL(url);
      onChange(payload);
      dispatch({ type: 'success' });
    } catch (error) {
      dispatch({ type: 'fail', payload: error });
    }
  }

  return (
    <React.Fragment>
      <label htmlFor={`${id.current}-url`} className="mb2 db dark-gray">
        Enter URL for Photo or Video below
      </label>
      <div className="flex">
        <input
          type="url"
          id={`${id.current}-url`}
          className="form-control"
          value={url}
          onChange={e => dispatch({ type: 'url', payload: e.target.value })}
        />
        <button
          type="submit"
          disabled={isLoading || !url}
          className={classnames('btn btn--link', {
            'btn--loading': isLoading,
          })}
          onClick={handleSubmit}
        >
          Add
        </button>
      </div>
      {error && (
        <div className="dark-red mt1">
          {error.message
            ? error.message
            : 'An error occurred while fetching this URL'}
        </div>
      )}
    </React.Fragment>
  );
}
function reducer(state, action) {
  switch (action.type) {
    case 'url':
      return {
        ...state,
        url: action.payload,
      };
    case 'submit':
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case 'success': {
      return {
        url: '',
        isLoading: false,
        error: null,
      };
    }
    case 'fail':
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
    default:
      throw new Error();
  }
}

async function getRemoteResourceType(url: string): Promise<string | null> {
  try {
    const response = await fetch(`https://cors-anywhere.herokuapp.com/${url}`, {
      method: 'HEAD',
    });
    if (response.ok) {
      const contentType = response.headers.get('content-type') || '';
      return contentType.split('/')[0];
    }
  } catch (error) {}

  return null;
}

async function validateMediaURL(url: string) {
  const isYoutube = isYoutubeVideo(url);
  const urlToValidate = isYoutube
    ? `https://img.youtube.com/vi/${getYoutubeVideoID(url) || ''}/0.jpg`
    : url;

  const resourceType = await getRemoteResourceType(urlToValidate);
  if (!resourceType) {
    throw new Error('Could not determine resource type');
  }
  if (resourceType !== 'image' && resourceType !== 'video') {
    throw new Error(`Unsupported resource type: ${resourceType}`);
  }

  if (isYoutube) {
    return {
      accessType: 'youtube',
      resourceType: 'video',
      url,
    };
  }
  return { resourceType, accessType: 'upload', url };
}



// WEBPACK FOOTER //
// ./src/components/ContentSection/__future__/MediaUpload/URLUploadControl.js